import React from 'react';
import { motion } from 'framer-motion';
import { FileWarning, UserX, Clock, TrendingDown } from 'lucide-react';
export function PainPoints() {
  const painPoints = [{
    icon: FileWarning,
    title: 'Reports full of charts, empty of revenue',
    description: "You get a 40-page PDF every month showing 'impressions' and 'backlinks built', but your pipeline is still dry and organic leads haven't increased."
  }, {
    icon: UserX,
    title: 'An account manager who Googles your industry',
    description: "You're tired of explaining your basic value proposition to a junior account manager who was assigned to your account yesterday."
  }, {
    icon: Clock,
    title: "Six months in and rankings haven't moved",
    description: '"SEO takes time" is the standard agency excuse for a lack of strategy. Yes, it takes time, but you should see leading indicators of growth in weeks, not years.'
  }, {
    icon: TrendingDown,
    title: 'Pressure from leadership to prove ROI',
    description: "Your CMO or CEO is asking what the SEO retainer is actually doing for the bottom line, and you don't have a clear, defensible answer."
  }];
  return <section className="py-24 bg-white relative overflow-hidden" id="process" data-id="element-164">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-165">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-166">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4 tracking-tight" data-id="element-167">
            You have been burned before.{' '}
            <span className="text-brand-600" data-id="element-168">We get it.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-169">
            Most marketing managers come to us after a failed agency engagement.
            The complaints are always the same.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-170">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative bg-slate-50 rounded-2xl p-8 hover:bg-white hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300 border border-slate-100" data-id="element-171">
              <div className="absolute top-0 left-0 w-1 h-full bg-brand-500 rounded-l-2xl opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-172"></div>
              <div className="flex items-start gap-6" data-id="element-173">
                <div className="flex-shrink-0" data-id="element-174">
                  <div className="w-12 h-12 rounded-xl bg-white shadow-sm border border-slate-100 flex items-center justify-center group-hover:bg-brand-50 group-hover:border-brand-100 transition-colors" data-id="element-175">
                    <point.icon className="w-6 h-6 text-slate-400 group-hover:text-brand-600 transition-colors" data-id="element-176" />
                  </div>
                </div>
                <div data-id="element-177">
                  <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-178">
                    {point.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed" data-id="element-179">
                    {point.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}